import { __assign, __spreadArray } from "tslib";
var ErrorLoggerImpl = /** @class */ (function () {
    function ErrorLoggerImpl(handlers) {
        this.handlers = [];
        this.handlers = handlers;
    }
    ErrorLoggerImpl.prototype.log = function (error, params) {
        this.handlers.forEach(function (h) { return h(error, params); });
    };
    ErrorLoggerImpl.prototype.createLoggingHandler = function (error, params) {
        var _this = this;
        return function (reason) {
            _this.log(error, __assign({ reason: reason }, params));
            return Promise.reject(reason);
        };
    };
    return ErrorLoggerImpl;
}());
var ErrorLoggerConfigurator = /** @class */ (function () {
    function ErrorLoggerConfigurator(handlers) {
        if (handlers === void 0) { handlers = []; }
        this.handlers = [];
        this.handlers = __spreadArray([], handlers, true);
    }
    ErrorLoggerConfigurator.prototype.addErrorHandler = function (handler) {
        return new ErrorLoggerConfigurator(__spreadArray(__spreadArray([], this.handlers, true), [handler], false));
    };
    ErrorLoggerConfigurator.prototype.createLogger = function () {
        return new ErrorLoggerImpl(this.handlers);
    };
    return ErrorLoggerConfigurator;
}());
export { ErrorLoggerConfigurator };
//# sourceMappingURL=error-logger.js.map